<form class="form-popup" [formGroup]="formGroup">
  <div class="modal-body">
    <div class="row top10 vcenter">
      <div class="col-xs-4 text-right">
        <b>Select Employee:</b>
      </div>
      <div class="col-xs-8">
        <aims-lookup style="width:100%"
                     name="SelectIndividuallyAssigned"
                     id="selectIndividuallyAssigned"
                     [gridText]="'Select an Employee to individually assign to Qualification: ' + qualDesc"
                     [values]="employeePuValues | async"
                     [idPropertyName]="'employeeId'"
                     [displayPropertyName]="'fullName'"
                     formControlName="employeeId"
                     [columnsInGrid]="reqQualForEmpLookupColumns">
        </aims-lookup>
      </div>
    </div>
  </div>
</form>
